import React from "react";
import { useTranslation } from "react-i18next";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Globe, Check, ChevronDown } from "lucide-react";

const LANGS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

export default function LanguageSwitcher({ variant = "desktop" }) {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    if (typeof document !== "undefined") {
      document.documentElement.lang = code;
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex items-center gap-2 text-white/90 hover:text-gold transition-colors focus:outline-none"
        data-testid="lang-switcher-trigger"
        aria-label="Language switcher"
      >
        <Globe className="h-4 w-4" />
        <span className="text-sm uppercase tracking-wider hidden md:inline">{current.code}</span>
        <ChevronDown className="h-3 w-3 opacity-70" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-black/95 backdrop-blur-md border border-gold/30 text-white min-w-[160px]"
        data-testid="lang-switcher-menu"
      >
        {LANGS.map((lang) => {
          const active = lang.code === current.code;
          return (
            <DropdownMenuItem
              key={lang.code}
              onSelect={() => change(lang.code)}
              className={`flex items-center gap-3 cursor-pointer focus:bg-gold/10 focus:text-gold ${active ? "text-gold" : ""}`}
              data-testid={`lang-option-${lang.code}`}
            >
              <span className="text-lg" aria-hidden="true">{lang.flag}</span>
              <span className="flex-1">{lang.label}</span>
              {active && <Check className="h-4 w-4" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
